import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, LogOut } from "lucide-react";
import { useNavigate } from "react-router";
import { useAuthContext } from "@/hooks/useAuthContext";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleLogout = async () => {
    const { error } = await logout();
    if (!error) {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-indigo-50 flex items-center justify-center p-4" dir="rtl">
      <Card className="w-full max-w-md bg-white shadow-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <Shield className="h-8 w-8 text-red-600" />
          </div>
          <CardTitle className="text-2xl font-semibold text-slate-900">גישה נדחתה</CardTitle>
          <CardDescription className="text-slate-600">אין לך הרשאות לגשת לעמוד זה</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-slate-600">
            <p className="mt-2">אם אתה חושב שזו טעות, פנה למנהל המערכת.</p>
          </div>

          <div className="flex flex-col gap-3">
            <Button onClick={handleGoHome} className="w-full bg-gradient-to-r from-sky-400 to-indigo-500 text-white">
              עבור לדף הבית
            </Button>
            {user && (
              <Button 
                onClick={handleLogout} 
                variant="outline" 
                className="w-full"
              >
                <LogOut className="h-4 w-4 mr-2" />
                התנתק
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UnauthorizedPage;
